// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  APP_NAME: "yodawe",
  API_BASE: "https://api.yodawe.com/",
  COGNITO_CLIENT_ID: "1rdkm979ck48g9ao4cilpe3skk",
  LOGIN_URI:
    "https://yodawe.auth.us-east-1.amazoncognito.com/login?redirect_uri=https://yodawe.com/login&response_type=code&client_id=1rdkm979ck48g9ao4cilpe3skk",
  production: true,
};
